(function(){
'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

angular.module('classy').component('cpCreditCardWidget', {
  template: '\n      <div class="cp-credit-card"\n      ng-class="{ \'details-mode\': $ctrl.mode === \'details\', \'details-mode-visited\': $ctrl.modeChanged, \'loaded\': $ctrl.loaded, \'has-postal\': !$ctrl.hidePostal, \'is-amex\': $ctrl.payment.brand === \'americanExpress\' }">\n\n        <form-label \n          ng-hide="$ctrl.hideLabel"\n          required="true"\n          _spec="label"\n        >{{:: $ctrl.label }}</form-label>\n\n        <ng-form name="$ctrl.form"\n        sc-validity-reporter="$ctrl.formName" class="cp-credit-card-form">\n\n          <div class="cp-credit-card__frame"\n          ng-class="{ error: $ctrl.numberInvalid }"\n          _spec="frame">\n\n            <div class="cp-credit-card__carousel">\n\n              <div class="cp-credit-card__number">\n                <div class="donation-label required">Card Number</div>\n                <div id="cc-entry-el" class="sr-only" tabindex="-1" aria-hidden="true">tab to enter credit card field</div>\n\n                <cp-tokenizer-control\n                ng-model="$ctrl.payment.token"\n                cmd-event="\'tokenizer\'"\n                on-valid="$ctrl.handleValidCard(brand, lastFour)"\n                on-token="$ctrl.handleToken(token)"\n                on-reset="$ctrl.handleReset()"\n                name="token"\n                card-brand="$ctrl.payment.brand"\n                sc-autofocus="1"\n                sc-validity-reporter\n                focus-field="$ctrl.focusField" \n                required>\n                </cp-tokenizer-control>\n\n              </div>\n\n              <div class="cp-credit-card__details">\n\n                <button class="cp-credit-card__go-to-number"\n                ng-click="$ctrl.userChangeMode(\'number\')"\n                type="button"\n                aria-label="go back to {{ $ctrl.payment.brand }} payment card number field for payment">\n\n                  <!-- Brand icon -->\n                  <span class="cp-credit-card__brand"\n                  ng-bind-html="$ctrl.brandIcon()"></span>\n\n                  <!-- Last four -->\n                  <span class="cp-credit-card__last-four">\n                    {{ $ctrl.payment.lastFour || \'1234\' }}\n                  </span>\n\n                </button>\n\n                <span class="sr-only" \n                aria-label="your current payment card brand is {{ $ctrl.payment.brand }} with the last four digits {{ $ctrl.payment.lastFour }}" \n                aria-live="polite"></span>\n\n              </div>\n            </div>\n          </div>\n          <div class="cp-credit-card-field-box" ng-class="{ error: $ctrl.expirationDateInvalid }">\n            <span class="donation-label required">Expiration Date</span>\n            <div class="cp-credit-card-field"\n              ng-class="{errorField: $ctrl.expirationDateInvalid}">\n              <!-- Expiration month -->\n              <input class="cp-credit-card__month"\n              ng-model="$ctrl.payment.expirationMonth"\n              sc-validity-reporter\n              sc-pattern="^(0[1-9]|1[0-2])$"\n              sc-restrict-input="^(0[1-9]?|1[0-2]?)$"\n              cp-validate-expiration="$ctrl.payment"\n              placeholder="MM"\n              name="expirationMonth"\n              sc-autofocus="2"\n              aria-label="please enter your payment card expiration month"\n              autocomplete = "cc-exp-month"\n              required />\n\n              <!-- Expiration slash -->\n              <span class="cp-credit-card__slash">/</span>\n\n              <!-- Expiration year -->\n              <input class="cp-credit-card__year"\n              ng-model="$ctrl.payment.expirationYear"\n              sc-validity-reporter\n              sc-pattern="^[0-9]{2}$"\n              sc-restrict-input="^[0-9]{0,2}$"\n              cp-validate-expiration="$ctrl.payment"\n              sc-autofocus="3"\n              placeholder="YY"\n              name="expirationYear"\n              aria-label="please enter the last 2 digits of your payment card expiration year"\n              autocomplete="cc-exp-year"\n              required />\n            </div>\n          </div>\n          <div class="cp-credit-card-field-box" ng-class="{ error: $ctrl.securityCodeInvalid }">\n            <!-- Security code -->\n            \n            <span class="donation-label required">Security code</span>\n            <div class="cp-credit-card-cvv-field" ng-class="{ errorField: $ctrl.securityCodeInvalid }"> \n             <div id="cp-tokenizer-control__cvv" title="Security code" aria-label="please enter your payment card security code" required></div>\n            </div>\n          </div>\n          <div class="cp-credit-card-field-box" ng-if="!$ctrl.hidePostal" ng-class="{ error: $ctrl.postalOrZipInvalid }">\n            <!-- Postal code -->\n            <span class="donation-label required">Postal code</span>\n            <div class="cp-credit-card-field" ng-class="{errorField: $ctrl.postalOrZipInvalid}">\n              <input class="cp-credit-card__postal-code"\n              ng-model="$ctrl.payment.postalCode"\n              ng-if="!$ctrl.hidePostal"\n              sc-validity-reporter\n              ng-minlength="2"\n              ng-maxlength="10"\n              placeholder="{{ $ctrl.zipName() }}"\n              name="postalCode"\n              aria-label="please enter your payment card postal code"\n              autocomplete="postal-code"\n              sc-autofocus="5"\n              required />\n            </div>\n          </div>\n        </ng-form>\n\n        <p class="form__error" ng-if="$ctrl.errorVisible" aria-live="polite" ng-bind="$ctrl.errorMessage">\n        </p>\n\n      </div>\n    ',
  bindings: {
    onToken: '&',
    onCard: '&',
    payment: '<',
    label: '<?',
    primaryColor: '<?',
    hidePostal: '<?',
    hideLabel: '<'
  },
  controller: ["$sce", "$scope", "$rootScope", "$templateCache", "$timeout", "scDigitalWalletsService", "scFeeOnTopService", function CpCreditCardWidgetCtrl($sce, $scope, $rootScope, $templateCache, $timeout, scDigitalWalletsService, scFeeOnTopService) {
    var _this2 = this;

    /* -------------------------------------------------------------------- *
     * Lifecycle
     * -------------------------------------------------------------------- */

    this.$onInit = function () {
      this.label = this.label || 'Card number';
      this.mode = 'number';
      this.modeChanged = false;
      this.formName = 'cpCreditCardWidget';
      this.numberInvalid = false;
      this.detailsInvalid = false;
      this.expirationDateInvalid = false;
      this.securityCodeInvalid = false;
      this.postalOrZipInvalid = false;
      this.errorVisible = false;
      this.focusField = null;
      $scope.$on('scValidity.update', updateErrorMessage.bind(this));
    };

    /* -------------------------------------------------------------------- *
     * View management
     * -------------------------------------------------------------------- */

    // When a valid credit card is first entered, automatically progress to
    // the next view.
    this.handleValidCard = function (brand, lastFour) {
      this.payment.brand = brand;
      this.payment.isAmex = brand === 'americanExpress';
      scFeeOnTopService.setAmex(this.payment.isAmex);
      $rootScope.$broadcast('donationPage:recalculateFees');
      this.payment.lastFour = lastFour;
      if (!this.modeChanged && this.form) {
        this.form.token.$blur();
        if (brand) {
          this.modeChanged = true;
          this.form.$autofocus('expirationMonth');
        }
      }
      this.onCard({ brand: brand, lastFour: lastFour });
    };

    this.handleToken = function (token) {
      this.onToken(token);
    };

    this.changeMode = function (mode, animate) {
      var _this = this;

      this.mode = mode;
      if (animate) {
        if (mode === 'details') {
          $timeout(function () {
            _this.modeChanged = true;
            _this.form.$autofocus('expirationMonth');
          }, 400);
        } else {
          $timeout(function () {
            _this.form.$autofocus('token');
          }, 400);
        }
      }
    };

    this.handleReset = function () {
      this.modeChanged = false;
      this.errorVisible = false;
      this.errorMessage = '';
      this.numberInvalid = false;
      this.detailsInvalid = false;
      this.expirationDateInvalid = false;
      this.securityCodeInvalid = false;
      this.postalOrZipInvalid = false;
      scFeeOnTopService.setAmex(false);
    };

    /* -------------------------------------------------------------------- *
     * View generators
     * -------------------------------------------------------------------- */

    this.brandIcon = function () {
      var html = void 0;
      switch (this.payment.brand) {
        case 'visa':
          html = $templateCache.get('global/classy-pay/svg/visa');
          break;
        case 'americanExpress':
          html = $templateCache.get('global/classy-pay/svg/amex');
          break;
        case 'discover':
          html = $templateCache.get('global/classy-pay/svg/discover');
          break;
        case 'masterCard':
          html = $templateCache.get('global/classy-pay/svg/mastercard');
          break;
        case 'diners':
          html = $templateCache.get('global/classy-pay/svg/diners-club');
          break;
        default:
          html = "<i class='cp-credit-card__brand-icon ci ci-credit-card'></i>";
          break;
      }
      return $sce.trustAsHtml(html);
    };

    this.codeName = function () {
      switch (this.payment.brand) {
        case 'masterCard':
        case 'maestro':
          return 'CVC';
        case 'americanExpress':
        case 'discover':
          return 'CID';
        default:
          return 'CVV';
      }
    };

    this.codePattern = function () {
      switch (this.payment.brand) {
        case 'americanExpress':
          return '^[0-9]{4}$';
        default:
          return '^[0-9]{3}$';
      }
    };

    this.zipName = function () {
      return this.payment.country === 'US' ? 'Zip' : 'Postal';
    };

    /* -------------------------------------------------------------------- *
     * Errors
     * -------------------------------------------------------------------- */

    $scope.$watch(function () {
      return _this2.payment.country;
    }, function () {
      _this2.form.$scValidityReporter.update();
    });

    /* Private
    ========================================================= */
    function updateErrorMessage(_event, alias, data) {
      if (alias !== this.formName) {
        return;
      }

      this.errorVisible = false;
      this.errorMessage = '';
      this.numberInvalid = false;
      this.detailsInvalid = false;
      this.expirationDateInvalid = false;
      this.securityCodeInvalid = false;
      this.postalOrZipInvalid = false;

      if (!this.shouldShowErrorMessage(data)) return;
      var uiError = data.error;

      var cvvIframe = document.querySelector('#tx_iframe_cvv_cp-tokenizer-control__cvv');
      this.errorVisible = true;

      // Card number is invalid, ensure we stay there
      if (!_.has(uiError.token, 'cvv') && _.size(uiError.token) || !this.payment.lastFour) {
        this.numberInvalid = true;
        this.errorMessage = 'Please enter a valid card number.';

        // It's possible to enter another number in the 400ms it takes to
        // transition to the details view, thus invalidating the card number,
        // So we transition to the number just to be sure.
        this.changeMode('number', false);

        return;
      }

      // Details are invalid, ensure we don't nav away
      this.detailsInvalid = true;

      if (_.get(uiError, 'expirationMonth.required') && _.get(uiError, 'expirationYear.required')) {
        this.errorMessage = 'Please enter an expiration date.';
        this.expirationDateInvalid = true;
      } else if (_.get(uiError, 'expirationMonth.scPattern') || _.get(uiError, 'expirationYear.scPattern')) {
        this.errorMessage = 'Please enter in MM/YY format.';
        this.expirationDateInvalid = true;
      } else if (_.get(uiError, 'expirationMonth.cpExpirationDate') || _.get(uiError, 'expirationYear.cpExpirationDate')) {
        this.errorMessage = 'Please enter a valid expiration date.';
        this.expirationDateInvalid = true;
      } else if (
      /**
       * On safari while navigating through a tab key it first focus on the cvvIframe field instead on CVV input field
       * Due to this CVV error message get displayed. To fix this we have added document.activeElement check just as a workaround.
       */
      document.activeElement !== cvvIframe && this.focusField !== 'cvv' && _.has(uiError.token, 'cvv')) {
        this.securityCodeInvalid = true;
        this.errorMessage = 'Please enter a valid security code.';
      } else if (document.activeElement !== cvvIframe && this.focusField !== 'cvv' && _.get(uiError, 'postalCode.required')) {
        if (this.payment.country === 'US') {
          this.errorMessage = 'Please enter a zip code.';
        } else {
          this.errorMessage = 'Please enter a postal code.';
        }
        this.postalOrZipInvalid = true;
      } else if (_.get(uiError, 'postalCode.minlength') || _.get(uiError, 'postalCode.maxlength')) {
        this.errorMessage = 'Please enter between 2 and 10 characters.';
        this.postalOrZipInvalid = true;
      }
    }

    this.shouldShowErrorMessage = function (validityData) {
      if (scDigitalWalletsService.isDigitalWalletSubmission) {
        return false;
      }
      var errorKeys = Object.keys(validityData.error);

      // if the form is not fully rendered, we won't show error messages yet
      if (errorKeys.length !== this.form.$$controls.length) return false;

      // reduce the error message objects into an array of keys indicating
      // how many individual errors there are
      var erroredFields = errorKeys.reduce(function (accum, key) {
        if (_.isEmpty(validityData.error[key])) return accum;
        return [].concat(_toConsumableArray(accum), [key]);
      }, []);

      // if no fields have any errors, just kick it out.
      if (!erroredFields.length) return false;

      // When the focus jumps from the token iframe to the expiration month we lose it for a
      // second, thus we don't show the error if we have one less errored field than the total
      // number of fields (discounting the token field, which handles it's own errors)
      if (validityData.uiValid && erroredFields.length >= errorKeys.length - 1) return false;

      // if they are still focused on a field, then don't show any error message at all
      for (var i = 0; i < errorKeys.length; i += 1) {
        var key = errorKeys[i];
        var $element = _.get(this.form, '[' + key + '].$$element');
        if ($element && $element.is(':focus')) return false;
      }

      return true;
    };
  }]
});
})();